import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormControl, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { Constants } from '../Constants';
import { LoginService } from '../login/login.service';
import { SharedService } from '../services/shared.service';
import { AsYouType, isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';
import * as _ from 'lodash';
import $ from 'jquery';
@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
	hide: Boolean;
  logo;
  signupForm: FormGroup;
  error: String = "";
  phoneError: boolean = false;
  orgerror: boolean = false;
  constructor(
    private _formBuilder: FormBuilder,
    private _router: Router,
    private _loginService: LoginService,
    private _sharedService: SharedService
  ) {
    this.signupForm = this._formBuilder.group({
      // org_name: new FormControl('', [Validators.required]),
      // org_code: new FormControl('', [Validators.required, Validators.pattern(/^[0-9a-zA-Z_]+$/)]),
      // org_email: new FormControl('', [Validators.required, Validators.pattern(Constants.emailPattern)]),
      // org_state: new FormControl('', [Validators.required]),
      user_first_name: new FormControl('', [Validators.required]),
      user_last_name: new FormControl('', [Validators.required]),
      user_email: new FormControl('', [Validators.required, Validators.pattern(Constants.emailPattern)]),
      user_password: new FormControl('', [Validators.required]),
      address: new FormControl('', []),
      pincode: new FormControl('', [Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/)]),
      phone: new FormControl('', []),
      // logo: new FormControl('')
      organizations: this._formBuilder.array([])
    });
    this.signupForm.valueChanges.subscribe(() => {
      this.error = "";
      this.orgerror = false;
    })
  }

  ngOnInit(): void {
    if (localStorage.getItem('email')) {
      let url = localStorage.getItem("organizationCode") + "/dashboard";
      this._router.navigateByUrl(url);
    }
    for(let i = 1; i <= Constants.maxOrgs; i++) {
      this.addOrganization()
    }
  }

  onSubmit(): void {
    if(this.signupForm.valid) {
      // const signUpFormData = new FormData();
      const formValue = this.signupForm.value;
      this.signupForm.controls['phone'].setErrors({
        invalidPhone: false
      })
      // for (let i in formValue) {
      //   if (formValue[i] instanceof Blob){  //  Check if key value is file
      //     signUpFormData.append(i, formValue[i], formValue[i].name ? formValue[i].name : "");
      //   }
      //   else {        
      //     signUpFormData.append(i, formValue[i]);
      //   }
      // }
      this.phoneError = false;
      _.forEach(formValue, (value, key) => {
        if(key == "phone" && (!value || !this.isValidPhone(value))) {
          // this.signupForm.controls['phone'].setErrors({ invalid: true })
          this.phoneError = true;
          this.signupForm.controls['phone'].setErrors({
            invalidPhone: true
          })
          return;
        }
      });
      let isAllEmpty = true;
      let orgNames = formValue.organizations.map((org) => {
        if(org.name != '') {
          isAllEmpty = false;
        }
        return org.name.toLowerCase()
      });
      if((new Set(orgNames).size != orgNames.length) && !isAllEmpty) {
        this.orgerror = true;
        return;
      }
      if(this.phoneError) {
        return;
      }
      this._loginService.signUp(formValue).subscribe((response: any) => {
        if(response['success']) {
          this._sharedService.openSnackBar("User signed up successfully");
          this._router.navigateByUrl("/login")
          this.signupForm.reset();
        } else {
          this._sharedService.openSnackBar(response['message'])
        }
      })

    } else {
      this.error = "Please enter valid details to proceed"
      this._sharedService.openSnackBar(this.error)
    }
  }

  onFileChange(event) {
    let filesAccepted = ["jpg", "jpeg", "png"]
    let file = event.target.files[0];
    if(file && file.type && file.type.split("/")[1] && filesAccepted.indexOf(file.type.split("/")[1]) == -1) {
      this._sharedService.openSnackBar("Only png, jpg and jpeg files are supported");
      return;
    }
    if(file && file.size > 5000000) {
      this.error = "Logo size cannot be greater than5 MB.";
      return;
    }
    if(file) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (evt) => {
        this.signupForm.controls['logo'].setValue(file);
        this.logo = reader.result;
      }
  
      reader.onerror = (error) => {
        this.error = "Failed to upload image"
      }
    }
  }

  get organizationsForm() {
    return this.signupForm.get('organizations') as FormArray
  }

  addOrganization(event?) {
    if(event) {
      event.stopPropagation();
      event.preventDefault();
    }
    
    let newOrganizationForm = this._formBuilder.group({
      name: new FormControl('')
    });
    this.organizationsForm.push(newOrganizationForm);
  }

  onDeletingOrg(event, index) {
    event.stopPropagation();
    event.preventDefault();

    this.organizationsForm.removeAt(index);
  }

  onPhoneNumberEdit(input) {
    try {
      

      this.phoneError = false;
      let phone = new AsYouType('US').input(input);
      if (input.length !== 4) {
        this.signupForm.controls['phone'].setValue(phone);
      }
      let parsedPhone = parsePhoneNumber(this.signupForm.controls['phone'].value, 'US');
      const re = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
      let nationalNumber = parsedPhone.formatNational();
      let valid = re.test(nationalNumber);
      if (!valid) {
        this.phoneError = true;
        return;
      }
      this.phoneError = false;
      return;
    } catch (error) {
      this.phoneError = true;
      return;
    }
  }

  onPincodeInput(event: any) {
    $('.numbersOnly').keyup(function () { 
      this.value = this.value.replace(/[^0-9()\-. ]/g,'');
    });
  }

  onPinInput(event: any) {
    return event.charCode >= 48 && event.charCode <= 57
  }

  isValidPhone(input) {
    let parsedPhone = parsePhoneNumber(this.signupForm.controls['phone'].value, 'US');
    const re = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
    let nationalNumber = parsedPhone.formatNational();
    let valid = re.test(nationalNumber);
    if (!valid) {
      this.phoneError = true;
      return false;
    }
    this.phoneError = false;
    return true;
  }
}
